import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=028a1995&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=028a1995&prod&scoped=true&lang=less"
import style1 from "./Config.vue?vue&type=style&index=1&id=028a1995&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a1995",
  null
  
)

export default component.exports